var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7604 0.0629983C11.6101 -0.183774 12.4957 0.316348 12.7384 1.18005C12.7793 1.32536 12.8 1.47575 12.8 1.62687V2.9883H14.4C15.2837 2.9883 16 3.71649 16 4.61476V14.3735C16 15.2718 15.2837 15.9999 14.4 15.9999H1.6C0.716344 15.9999 0 15.2718 0 14.3735H0.0213411C0.00715415 14.2861 0 14.1975 0 14.1087V4.41508C0 3.6889 0.473564 3.05071 1.16045 2.85121L10.7604 0.0629983ZM6.5125 14.3735H14.4V7.86787H12.8V6.24141H14.4V4.61476H12.8V11.3205C12.8 12.0467 12.3264 12.6849 11.6396 12.8844L6.5125 14.3735ZM1.59985 4.41501V14.1087L11.1999 11.3205V1.6268L1.59985 4.41501ZM9.6 6.24124C9.6 6.69037 9.24183 7.05447 8.8 7.05447C8.35817 7.05447 8 6.69037 8 6.24124C8 5.79211 8.35817 5.42801 8.8 5.42801C9.24183 5.42801 9.6 5.79211 9.6 6.24124Z",
    fill: "#284FAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDebit);
export default __webpack_public_path__ + "static/media/ic-debit.c088270d2c01313b923597c662b7d80e.svg";
export { ForwardRef as ReactComponent };